<template>
  <div class="filter-tree">
    <el-input
      placeholder="输入关键字进行过滤"
      v-model="filterText"
      size="small"
      suffix-icon="el-icon-search"
    />

    <div class="filter-tree__content">
      <el-tree
        ref="tree"
        :data="treeData"
        :props="defaultProps"
        @node-click="handleNodeClick"
        :expand-on-click-node="false"
        node-key="id"
        :filter-node-method="filterNode"
        :highlight-current="true"
        :default-expanded-keys="USER ? parentIds : []"
      >
        <span
          class="filter-tree__node"
          slot-scope="{ node, data }"
        >
          <i class="filter-tree__tree-icon iconfont icon-user" />
          <span>{{ data.username }}</span>
          <span class="filter-tree__total">({{ data.parentId === 0?data.sum:data.sum+1 }})</span>
          <span
            class="filter-tree__icon-box"
            v-if="USER && USER.userId !== data.id"
          >
            <template v-if="USER.type === 1?true:false">
              <i
                class="filter-tree__icon iconfont"
                v-for="item in iconList"
                :key="item.value"
                :class="item.icon"
                :title="item.title"
                @click.stop="handleUserClick(item.value, data)"
              />
            </template>
          </span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { toTreeData } from "@/assets/js/base";

export default {
  props: {
    value: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      arr:[],
      filterText: "",
      currentNode: null,
      parentIds: [],
      defaultProps: {
        children: "children",
        label: "username"
      },
      iconList: [
        { icon: "icon-Caraddinggroup", title: "添加用户", value: "onAddUser" },
        {
          icon: "icon-Deletetrainset",
          title: "删除用户",
          value: "onDeleteUser"
        },
        { icon: "icon-modify-", title: "修改用户", value: "update" }
      ]
    };
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    USERLIST() {
      if (this.currentNode) { //新增或者删除 映射值同步修改
        this.parentIds = this.getParentNodeIds(this.currentNode)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentNode); 
        });
        let node = this.getUserNode(this.currentNode)
        this.$emit("input", node ? this.getUserIds(node) : []);
      }
    },
  },

  computed: {
    ...mapState(["USER", "USERLIST"]),
    treeData() {
      return this.treeFormat(this.USERLIST);
    }
  },

  mounted() {
    this.parentIds = [this.USER.userId];
  },

  methods: {
    //转换成标准树形数据
    treeFormat(data) {
      for (let item of data) {
        item.children = item.userList;
        item.total = item.total || 1;
        if (item.userList && item.userList.length > 0) {
          item.total += 1;
          this.treeFormat(item.userList);
        }
      }
      return data;
    },
    getParentNodeIds(id) {
      let nodes = [];
      let fn = function (his, targetId, tree) {
        tree.some((list) => {
          const children = list.userList || [];
          if (list.id === targetId) {
            nodes = his;
            return true
          } else if (children.length > 0) {
            const history = [...his];
            history.push(list.id);
            return fn(history, targetId, children)
          }
        })
      }
      fn([], id, this.USERLIST)
      return nodes
    },
    getUserNode(id) {
      let hasFound = false, // 表示是否有找到id值
        result = null
      let fn = function (data) {
        if (Array.isArray(data) && !hasFound) { // 判断是否是数组并且没有的情况下，
          data.forEach(item => {
            if (item.id == id) { // 数据循环每个子项，并且判断子项下边是否有id值
              result = item; // 返回的结果等于每一项
              hasFound = true; // 并且找到id值
            } else if (item.userList) {
              fn(item.userList); // 递归调用下边的子项
            }
          })
        }
      }
      fn(this.USERLIST);
      return result
    },
    getUserIds(node) {
      let ids = [node.id];
      runChildNodes(node);
      return ids;

      function runChildNodes(node) {
        if (node.userList) {
          node.userList.map(item => {
            ids.push(item.id);
            runChildNodes(item);
          });
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return (
        data.username.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) !==
        -1
      );
    },
    handleUserClick(type, data) {
      switch (type) {
        case "onAddUser":
          this.$emit("onHandleUser", "addThis", data);
          break;
        case "onDeleteUser":
          this.$emit("onDeleteUser", { data: [data] });
          break;
        case "update":
          this.$emit("onHandleUser", "update", {
            ...data
          });
          break;
      }
    },
    handleNodeClick(data, node) {
      this.currentNode = data.id
      this.$emit("input", getUserIds(node));
      function getUserIds(node) {
        let ids = [node.data.id];
        runChildNodes(node);
        return ids;

        function runChildNodes(node) {
          if (node.childNodes) {
            node.childNodes.map(item => {
              ids.push(item.data.id);
              runChildNodes(item);
            });
          }
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-tree {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__content {
    margin-top: 16px;
    flex: 1;
    overflow-y: auto;
    @include scrollBar;
  }

  &__node {
    display: flex;
    align-items: center;
  }

  &__tree-icon {
    margin-right: 5px;
    font-size: 14px;
    color: #18c18b;
  }

  &__icon-box {
    display: none;
  }

  &__icon {
    margin-left: 10px;
    color: #cfcfcf;
    font-size: 14px;

    & + & {
      margin-left: 5px;
    }

    &:hover {
      color: #18c18b;
    }
  }
}

.el-tree-node__content {
  &:hover {
    .filter-tree__icon-box {
      display: block;
    }
  }
}
</style>
